// core
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { DateRange, DebtModel, extractDateRange, extractDefaultStoreIds, extractNumberArr, HxReportService, HxStoreService, toRouterQueryParams } from 'hx-services';
import { Subscription } from 'rxjs';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { HxConfirmModalComponent, HxDateRangeSelectComponent, HxLoaderComponent, HxModalData, HxStoreSelectComponent } from 'hx-component';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { FormsModule } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';

interface SelectableDebt extends DebtModel {
  selected?: boolean;
}

/**
 * Report: list of user with money under salary (name, quality, money)
 * отчёт Деньги в счёт зарплаты
 */
@Component({
    selector: 'app-under-salary.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './under-salary.component.html',
    styleUrls: ['./under-salary.component.css'],
    imports: [HxStoreSelectComponent, FormsModule, HxDateRangeSelectComponent, NgIf, NgClass, NgFor, RouterLink, NgbTooltip, HxLoaderComponent, TranslocoPipe]
})
export class UnderSalaryComponent implements OnInit, OnDestroy {
  list: SelectableDebt[] = [];
  isLoading = {
    list: false,
    close: false,
  };
  params: { date?: DateRange, debtor?: boolean, storeIds?: number[] } = {};
  currencySymbol: string;
  isAll = false;
  selectedItemCount = 0;
  userIds: number[] = [];
  private sub: Subscription;

  constructor(
    private reportService: HxReportService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private modal: NgbModal,
    private toastr: HcToastrService,
    private storeService: HxStoreService,
    private tr: TranslocoService
  ) {
  }

  ngOnInit() {
    this.userIds = [];
    this.sub = this.aRoute.queryParamMap.subscribe(paramMap => {
      this.params.date = extractDateRange('date', paramMap);
      this.params.storeIds = extractNumberArr('storeIds', paramMap);
      if (this.params.storeIds.length === 0) {
        this.params.storeIds = extractDefaultStoreIds();
      }
      this.params.debtor = paramMap.get('debtor') === 'true';
      if (this.params.storeIds.length > 0) {
        this.loadList();
      }
    });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  toggleDebt(debt: SelectableDebt): void {
    debt.selected = !debt.selected;
    this.selectedItemCount = this.list.filter(r => r.selected).length;
  }

  checkAll(): void {
    this.list.forEach(order => order.selected = this.isAll);
    this.selectedItemCount = this.list.filter(r => r.selected).length;
  }

  closeDebtItem(item: DebtModel) {
    this.userIds.push(item.user.id);
    this.closeDebt();
  }

  closeDebtList() {
    this.userIds = this.list.filter(r => r.selected).map(r => r.user.id);
    this.closeDebt();
  }

  getTypeFilter(): void {
    this.navigate();
  }

  private closeDebt() {
    this.isLoading.close = true;
    const modalInstance = this.modal.open(HxConfirmModalComponent, {size: 'lg'});
    modalInstance.componentInstance.data = {
      message: 'debt.close.question',
      confirmMessage: 'debt.continue.yes',
      cancelMessage: 'debt.continue.no'
    } as HxModalData;
    modalInstance.result.then(() => {
      this.reportService.closeDebt({
        dateFrom: this.params.date?.from,
        dateTo: this.params.date?.to,
        storeIds: this.params.storeIds,
        userIds: this.userIds,
      }).subscribe(() => {
        this.selectedItemCount = 0;
        this.toastr.success(this.tr.translate('under-salary.ts.debtSuccess'));
        this.isLoading.close = false;
        this.loadList();
      }, () => {
        this.toastr.error(this.tr.translate('under-salary.ts.fatal'));
        this.isLoading.close = false;
      });
    }, (reason) => {
      console.log('Dismissed reason : ', reason);
    });
  }

  private loadList() {
    this.isLoading.list = true;
    this.list = [];
    this.reportService.getDebts(this.params).subscribe(result => {
      this.list = result;
      this.isLoading.list = false;
    }, err => this.isLoading.list = false);
  }

  private navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }
}
